/**
* Bottle Cap CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Bottle Cap CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'bottle-cap-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.bottle-caps__cap' ).on( 'mouseover', function() {
        const cap = this;
        $( cap ).addClass( 'is-spinning' );

        setTimeout( function() {
          $( cap ).removeClass( 'is-spinning' );
        }, 5000 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'bottle-cap-cta', COMPONENT );
} )( app );
